// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
// TODO: ts-nocheck genera problemas con el DateRangePicker, hay que sacar el DateRangePicker de este tsx
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';
import { useState, useEffect } from 'react';
import { Card, CardBody, Button, Divider } from '@nextui-org/react';
import { DateRangePicker } from 'react-date-range';
import { formatDate, formatPrice } from 'common/src/utils/functions';
import { FaTasks, FaCheckCircle, FaUsers, FaDollarSign } from 'react-icons/fa';
import useUserStore from '../../store/useUserStore';
import { Select, SelectItem } from '@nextui-org/react';
import useGeneralStore from '../../store/useGeneralStore';
import LineChart from '../../components/charts/LineChart';
import { fetchAnalyticsData } from 'common/src/api/analytics';
import { ROLES } from '../../types/constans';
import { fetchAllTaskComplete, fetchTaskRejectedAndDraft } from 'common/src/api/tasks';

const HomePage = () => {
  const { userProfile } = useUserStore();
  const { users } = useGeneralStore();
  const isAdmin = userProfile?.role.includes(ROLES.ADMIN);
  const isHelper = userProfile?.role.includes(ROLES.HELPER);
  const [, setTasksCount] = useState(0);
  const [taskersCount, setTaskersCount] = useState(0);
  const [dateRange, setDateRange] = useState(() => {
    const today = new Date();
    const firstDayOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
    const lastDayOfMonth = new Date(today.getFullYear(), today.getMonth() + 1, 0);
    return [
      {
        startDate: firstDayOfMonth,
        endDate: lastDayOfMonth,
        key: 'selection',
      },
    ];
  });
  const [pendingTasksCount, setPendingTasksCount] = useState(0);
  const [doneTasksCount, setDoneTasksCount] = useState(0);
  const [isCalendarOpen, setIsCalendarOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [selectedUser, setSelectedUser] = useState<string | null>(null);
  const [newTaskersData, setNewTaskersData] = useState<number[]>([]);
  const [newTaskersLabels, setNewTaskersLabels] = useState<string[]>([]);
  const [totalMoneyData, setTotalMoneyData] = useState<number[]>([]);
  const [totalMoneyLabels, setTotalMoneyLabels] = useState<string[]>([]);
  const [tasksArrivedData, setTasksArrivedData] = useState<number[]>([]);
  const [tasksArrivedLabels, setTasksArrivedLabels] = useState<string[]>([]);
  const [completedTasksData, setCompletedTasksData] = useState<number[]>([]);
  const [completedTasksLabels, setCompletedTasksLabels] = useState<string[]>([]);
  const [completedTasksTotal, setCompletedTasksTotal] = useState(0);

  const toggleCalendar = () => {
    setIsCalendarOpen(!isCalendarOpen);
  };

  const handleDateRangeChange = (item: {
    selection: { startDate: Date; endDate: Date; key: string };
  }) => {
    setDateRange([item.selection]);
    setIsCalendarOpen(false);
  };

  // TODO: Arreglar este fetch demasiada logica encapsulada
  const fetchAnalytics = async () => {
    setIsLoading(true);
    try {
      const userId = isAdmin ? selectedUser : userProfile?.id?.toString();
      const analyticsData = await fetchAnalyticsData(
        dateRange[0].startDate,
        dateRange[0].endDate,
        userProfile,
        userId || null
      );

      // Obtener todas las tasks excluyendo draft y rejected
      // TODO Abstraer toda la logica de consultas a supabase en otro lugar.
      const { data: activeTasks, error } = await fetchTaskRejectedAndDraft(dateRange[0].startDate.toISOString(), dateRange[0].endDate.toISOString())

      if (error) {
        console.error('Error fetching tasks:', error);
        throw error;
      }

      console.log('Tasks activas encontradas:', {
        total: activeTasks?.length,
        tasks: activeTasks,
        fechaInicio: dateRange[0].startDate.toISOString(),

        fechaFin: dateRange[0].endDate.toISOString()

      });

      setPendingTasksCount(activeTasks?.length || 0);

      // Consulta adicional para tasks no draft
      if (isAdmin) {
        const { data: nonDraftTasks, error } = await fetchTaskDraft(dateRange[0].startDate.toISOString(), dateRange[0].endDate.toISOString())

        if (error) throw error;

        const nonDraftTasksCount = nonDraftTasks?.length || 0;
        setTasksCount(nonDraftTasksCount);
      }

      console.log('Analytics data:', JSON.stringify(analyticsData, null, 2));

      setDoneTasksCount(analyticsData.doneTasksCount || 0);

      const MAX_ARRAY_LENGTH = 1000; // Reduce maximum length to ensure better performance
      const MAX_SAFE_NUMBER = 1e9; // Set a reasonable maximum number for chart data

      const safeSetArrayData = (
        setLabels: React.Dispatch<React.SetStateAction<string[]>>,
        setData: React.Dispatch<React.SetStateAction<number[]>>,
        labels?: string[],
        data?: number[]
      ) => {
        if (Array.isArray(labels) && Array.isArray(data) && labels.length === data.length) {
          const length = Math.min(labels.length, MAX_ARRAY_LENGTH);
          const safeLabels = labels.slice(0, length);
          const safeData = data.slice(0, length).map((value) => {
            if (typeof value === 'number' && isFinite(value)) {
              return Math.min(Math.max(value, -MAX_SAFE_NUMBER), MAX_SAFE_NUMBER);
            }
            return 0;
          });
          setLabels(safeLabels);
          setData(safeData);
        } else {
          console.error('Invalid data structure for chart:', { labels, data });
          setLabels([]);
          setData([]);
        }
      };

      safeSetArrayData(
        setTasksArrivedLabels,
        setTasksArrivedData,
        analyticsData.tasksArrivedData?.labels,
        analyticsData.tasksArrivedData?.data
      );

      if (isAdmin) {
        setTaskersCount(analyticsData.taskersCount || 0);
        safeSetArrayData(
          setNewTaskersLabels,
          setNewTaskersData,
          analyticsData.newTaskersData?.labels,
          analyticsData.newTaskersData?.data
        );
      }

      safeSetArrayData(
        setTotalMoneyLabels,
        setTotalMoneyData,
        analyticsData.incomeData?.labels,
        analyticsData.incomeData?.data
      );

      safeSetArrayData(
        setCompletedTasksLabels,
        setCompletedTasksData,
        analyticsData.completedTasksData?.labels,
        analyticsData.completedTasksData?.data
      );
    } catch (error) {
      console.error('Error fetching analytics:', error);
    } finally {
      setIsLoading(false);
    }
  };

  // $$$
  const fetchCompletedTasksTotal = async () => {
    try {
      let query = fetchAllTaskComplete()

      if (userProfile?.role.includes('helper')) {
        query = query.eq('assigned_user_id', userProfile.id);
      }

      const { data, error } = await query;

      if (error) throw error;

      const total = data.reduce((sum, task) => sum + (task.price || 0), 0);
      setCompletedTasksTotal(total);
    } catch (error) {
      console.error('Error fetching completed tasks total:', error);
    }
  };

  useEffect(() => {
    fetchAnalytics();
    fetchCompletedTasksTotal();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    fetchCompletedTasksTotal();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userProfile, dateRange]);

  const handleUserSelect = (value: string) => {
    setSelectedUser(value === 'all' ? null : value);
  };

  return (
    <div className="p-4 md:p-8">
      <div className="flex flex-col md:flex-row justify-between items-center mb-6">
        <div className="flex flex-col">
          <h1 className="text-xl md:text-2xl font-bold mb-4 md:mb-0">
            Hola {userProfile?.first_name}!
          </h1>
          <p className="text-sm md:text-base text-neutral-500">
            Aquí tienes un resumen sobre la actividad de Tasky!
          </p>
        </div>
      </div>

      <div className="flex flex-col md:flex-row  gap-4 items-center mb-6">
        {userProfile?.role.includes('admin') && (
          <Select
            items={[
              { label: 'Todos los usuarios', value: 'all' },
              ...users.map((user) => ({
                label: `${user.first_name} ${user.last_name}`,
                value: user.id.toString(),
              })),
            ]}
            label="Filtrar por usuario"
            placeholder="Seleccionar un usuario"
            className="w-40"
            variant="bordered"
            size="sm"
            onChange={(e) => handleUserSelect(e.target.value)}
            defaultSelectedKeys={['all']}
          >
            {(user) => (
              <SelectItem key={user.value} value={user.value}>
                {user.label}
              </SelectItem>
            )}
          </Select>
        )}
        <Button
          onClick={toggleCalendar}
          className="border-2 border-neutral-300 text-neutral-500 bg-white font-bold py-5  px-4 rounded"
        >
          {formatDate(dateRange[0].startDate)} - {formatDate(dateRange[0].endDate)}
        </Button>
        <Button
          onClick={() => fetchAnalytics()}
          className="bg-purple-600 text-white font-bold py-2 px-4 rounded"
        >
          Actualizar Datos
        </Button>
      </div>

      <Divider className="my-4" />
      {isLoading ? (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 mb-8">
          {[...Array(4)].map((_, index) => (
            <div
              key={index}
              className="flex flex-col items-center justify-center h-40 bg-gray-200 animate-pulse"
            >
              <div className="h-10 w-10 bg-gray-300 rounded-full mb-2"></div>
              <div className="h-6 w-20 bg-gray-300 mb-2"></div>
              <div className="h-4 w-32 bg-gray-300"></div>
            </div>
          ))}
        </div>
      ) : (
        <>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mb-8">
            <Card className="flex flex-col items-center justify-center h-40">
              <CardBody className="flex flex-col items-center justify-center">
                <FaTasks className="text-4xl mb-2" />
                <p className="text-3xl font-bold">{pendingTasksCount}</p>
                <p className="text-lg font-semibold">Tasks Activas</p>
              </CardBody>
            </Card>
            <Card className="flex flex-col items-center justify-center h-40">
              <CardBody className="flex flex-col items-center justify-center">
                <FaCheckCircle className="text-4xl mb-2" />
                <p className="text-3xl font-bold">{doneTasksCount}</p>
                <p className="text-lg font-semibold">Tasks Completadas</p>
              </CardBody>
            </Card>
            {userProfile?.role.includes('admin') && (
              <Card className="flex flex-col items-center justify-center h-40">
                <CardBody className="flex flex-col items-center justify-center">
                  <FaUsers className="text-4xl mb-2" />
                  <p className="text-3xl font-bold">{taskersCount}</p>
                  <p className="text-lg font-semibold">Nuevos Taskers</p>
                </CardBody>
              </Card>
            )}
            <Card className="flex flex-col items-center justify-center h-40">
              <CardBody className="flex flex-col items-center justify-center">

                <FaDollarSign className="text-4xl mb-2" />
                <p className="text-3xl font-bold">{formatPrice(completedTasksTotal)}</p>
                <p className="text-lg font-semibold">
                  {isHelper ? 'Tu Ganancia' : 'Dinero Total'}

                </p>
              </CardBody>
            </Card>
          </div>
          <div className="space-y-8">
            <Card className="w-full">
              <CardBody>
                <LineChart
                  chartData={[
                    {
                      name: isHelper ? 'Tus Tasks' : 'Tasks Totales',
                      data: tasksArrivedData,
                    },
                  ]}
                  chartLabels={tasksArrivedLabels}
                  title={isHelper ? 'Tus Tasks' : 'Tasks Totales'}
                />
              </CardBody>
            </Card>
            {isAdmin && (
              <Card className="w-full">
                <CardBody>
                  <LineChart
                    chartData={[{ name: 'New Taskers', data: newTaskersData }]}
                    chartLabels={newTaskersLabels}
                    title="Nuevos Taskers"
                  />
                </CardBody>
              </Card>
            )}
            {isAdmin && (
              <Card className="w-full">
                <CardBody>
                  <LineChart
                    chartData={[{ name: 'Total Money', data: totalMoneyData }]}
                    chartLabels={totalMoneyLabels}
                    title="Dinero Total"
                  />
                </CardBody>
              </Card>
            )}
            <Card className="w-full">
              <CardBody>
                <LineChart
                  chartData={[{ name: 'Completed Tasks', data: completedTasksData }]}
                  chartLabels={completedTasksLabels}
                  title="Tasks Completadas"
                />
              </CardBody>
            </Card>
          </div>
        </>
      )}
      {isCalendarOpen && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
          <div className="bg-white p-4 rounded-lg relative">
            <h2 className="text-xl font-semibold mb-4">Select Date Range</h2>
            <DateRangePicker
              onChange={handleDateRangeChange}
              moveRangeOnFirstSelection={false}
              ranges={dateRange}
              months={2}
              direction="horizontal"
            />
            <button
              onClick={toggleCalendar}
              className="absolute bottom-4 right-4 text-blue-500 hover:text-blue-700 font-bold"
            >
              Close
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default HomePage;
